import { getChild } from "react-nanny";
import { getChildrenByTypeNullable } from "./layouts/get-child-by-type";
import { Slot } from "./layouts/slot";

const Case = Slot<{
  value: string;
}>();

const Container = <T extends string>(props: {
  children: React.ReactNode;
  value: T;
}) => {
  const children = getChildrenByTypeNullable(props.children, Case);
  if (children) {
    const child = getChild(
      children,
      (c) => (c as any).props.value === props.value
    );
    return <>{child}</>;
  }

  return <></>;
};

export const Switch = {
  Container,
  Case,
};
